import type { FC } from 'react';

import { Alert, Button, Dialog, Sheet, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { PROMO_GUIDE_SHEET_LINK } from './PromoGuideSheet.config';
import styles from './PromoGuideSheet.module.scss';
import { PromoGuideSheetTexts } from './PromoGuideSheet.texts';

type PromoGuideSheetProps = { visible: boolean; onClose: () => void; onButtonClick: () => void };

export const PromoGuideSheet: FC<PromoGuideSheetProps> = ({ visible, onClose, onButtonClick }) => {
  const isMobile = useIsMobile();

  const Variant = isMobile ? Sheet : Dialog;

  return (
    <Variant visible={visible} onClose={onClose} className={styles.container}>
      <Variant.Header>
        <Typography.Text size={20} className={styles.title} strong>
          {PromoGuideSheetTexts.title}
        </Typography.Text>
      </Variant.Header>
      <Variant.Content>
        <Space direction="vertical" size={16}>
          <Space direction="vertical" size={16}>
            <Typography.Text className={styles.content}>{PromoGuideSheetTexts.content}</Typography.Text>
            <Alert variant="secondary" className={styles.description} color="dark">
              {PromoGuideSheetTexts.description}
            </Alert>
          </Space>

          <a
            onClick={() => {
              window.open(PROMO_GUIDE_SHEET_LINK, '_blank', 'noopener');
            }}
          >
            {PromoGuideSheetTexts.linkText}
          </a>
        </Space>
      </Variant.Content>
      <Variant.Footer>
        <Button onClick={onButtonClick} variant="primary" size={52} block>
          {PromoGuideSheetTexts.buttonText}
        </Button>
      </Variant.Footer>
    </Variant>
  );
};
